import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import getCode from './utils';



export interface CarTypesInterface {
    name: string,
    createdAt: string,
    value: number,
    image: File,
}

class CarTypesService {

    _fr = firebase.firestore(); 
    _st = firebase.storage(); 

    async getTypes(): Promise<firebase.firestore.QuerySnapshot>{
        return await this._fr.collection("car_types").get();
    }

    async createType(params: CarTypesInterface){
        const filePath = await (await this._st.ref("car_types/" + getCode()).put(params.image)).ref.getDownloadURL();
        params.image = filePath;

        return await this._fr.collection("car_types").add(params);
    }

    async deleteType(typeId: string){
        const usersContainers = await this._fr.collection("users").where("carTypeId", "==", typeId).get();

        if(usersContainers.docs.length){
            await Promise.all(
                usersContainers.docs.map( element => {
                    return this._fr.collection("users").doc(element.id).set({
                        carTypeId: "hYzf0GOAYGJ4kOdxu2qZ",
                    }, { merge: true })
                })
            );
        }

        return await this._fr.collection("car_types").doc(typeId).delete();
    }
}

export default CarTypesService;